import React from 'react';
import { Button } from '../ui/button';
import { ArrowLeft } from 'lucide-react';

const GameHeader = ({ deckInfo, onBackClick }) => {
  return (
    <div className="flex items-center justify-center gap-4 mb-2">
      <Button
        onClick={onBackClick}
        size="sm"
        variant="outline"
        className="bg-white/10 border-gray-600 text-white hover:bg-white/20"
      >
        <ArrowLeft className="w-4 h-4 mr-1" />
        Change Mode
      </Button>
      <div className="text-center">
        <h1 className="text-4xl font-bold text-white flex items-center justify-center gap-2">
          <span className="text-2xl">{deckInfo.icon}</span>
          {deckInfo.name} Battle
        </h1>
        <p className="text-white text-xl font-semibold mt-2 tracking-wide">What's more popular?</p>
      </div>
    </div>
  );
};

export default GameHeader;